import Link from 'next/link';
import { ReactElement } from 'react';

export interface ISiteMapData {
  url: string;
  title: string;
}

function SiteMapList({ items }): ReactElement {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 place-items-start ">
      {items?.map((item: ISiteMapData, index) => (
        <Link
          href={`${item.url}`}
          key={index}
          className="text-primary hover:underline hover:text-primary"
          target="_blank"
          rel="noopener noreferrer"
          title={item.title}
        >
          »{item.title}
        </Link>
      ))}
    </div>
  );
}

export default SiteMapList;
